module.exports = __webpack_public_path__ + "media/images/decorations/decoration-2-963305cefbe937a50d44a85e9e4023b2.svg";